import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LmsService } from "../../_Lms/services/lms.service";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
declare var $: any;

@Component({
  selector: 'app-mst-cluster-list',
  templateUrl: './mst-cluster-list.component.html',
  styleUrls: ['./mst-cluster-list.component.scss'],
  standalone: false
})
export class MstClusterListComponent implements OnInit {
  private data: any;
  private _MasterService;
  showSpinner: boolean = false;
  dataSource: any;
  JsonData: any[] = [];
  loading: boolean = false;
  // Fix: corrected columns to match GetClusterListViewModal model
  displayedColumns: string[] = [
    "StateId",
    "Cluster_Name",
    "Cluster_Code",
    "Region_Name",
    "Branch_Count",
    "Action",
  ];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  ClusterList: any = [];
  RegionListDropdown: any = [];
  SaveClusterRequestModel: RequestModel = new RequestModel();
  editClusterObj: any = {};
  selectedRegionId: any = "";

  constructor(
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private LmsService: LmsService
  ) {
    this._MasterService = MasterService;
    this.data = JSON.parse(sessionStorage.getItem("currentUser"));
  }

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Cluster List");
    this.getClusterList();
    // Fix: use GetRegionMaster for region dropdown instead of GetZoneListDropdown
    this.LmsService.GetRegionMaster().subscribe((result) => {
      this.RegionListDropdown = JSON.parse(JSON.stringify(result));
    });
  }

  getClusterList() {
    this.showSpinner = true;
    // Fix: GetClusterMaster was missing from MasterService, using LmsService
    this.LmsService.GetClusterMaster().subscribe((result: any) => {
      this.ClusterList = JSON.parse(JSON.stringify(result));
      this.dataSource = new MatTableDataSource(this.ClusterList);
      this.JsonData = result;
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.showSpinner = false;
    });
  }

  exportexcelNew(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    // Fix: corrected table id and worksheet name for cluster
    const table = document.getElementById("Cluster_List") as HTMLTableElement;
    const worksheetName = "MASTER_CLUSTER_LIST";
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  onAddCluster() {
    this.editClusterObj = {};
    this.selectedRegionId = "";
    $("#EditClusterModal").modal("show");
    $("#EditClusterModal").css("z-index", "1050");
  }

  onEditCluster(row: any) {
    this.editClusterObj = { ...row };
    // Fix: Cluster_RegionId does not exist in model, use RegionId
    this.selectedRegionId = row.RegionId;
    $("#EditClusterModal").modal("show");
    $("#EditClusterModal").css("z-index", "1050");
  }

  onSaveCluster() {
    // Fix: map all fields as per SaveClusterMasterRequest model
    this.SaveClusterRequestModel.ClusterId = this.editClusterObj.ClusterId;
    this.SaveClusterRequestModel.ClusterName = this.editClusterObj.Cluster_Name;
    this.SaveClusterRequestModel.Cluster_Code = this.editClusterObj.Cluster_Code;
    this.SaveClusterRequestModel.RegionId = parseInt(this.selectedRegionId);
    this.SaveClusterRequestModel.LoginUserId = this.data.userId;
    this.LmsService
      .SaveClusterMaster(this.SaveClusterRequestModel)
      .subscribe((response) => {
        const msg = response?.[0]?.MSG || "Saved successfully";
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: msg,
          ...this.configSuccess,
        });
        $("#EditClusterModal").modal("hide");
        this.onCloseModal();
        this.getClusterList();
      });
  }

  onCloseModal() {
    this.editClusterObj = {};
    this.selectedRegionId = "";
    $("#EditClusterModal").modal("hide");
  }
}
